import useMainStore from "@/store/index";
import { createRouter, createWebHistory } from "vue-router";

import AtmFrontChildrens from "@/router/childrens/atm-front-children";
import getOidcUser from "@/router/middleware/getOidcUser";
import { useAuth, useOidcStore } from "vue3-oidc";

const OidcCallback = () => import("@/components/OidcCallback.vue");
const AtmFront = () => import("@/components/AtmFront.vue");

const routes = [
  {
    path: "/",
    component: AtmFront,
    children: AtmFrontChildrens,
    beforeEnter: async (to, from, next) => {
      const mainStore = useMainStore();
      const oidcStore = useOidcStore();
      await getOidcUser(oidcStore);
      await mainStore.initFetch();
      next();
    },
  },
  {
    path: "/oidc-callback", // Needs to match redirect_uri in you oidcSettings
    name: "oidcCallback",
    component: OidcCallback,
    meta: {
      isPublic: true,
    },
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: "/",
  },
];

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
});

router.beforeEach(async (to, from, next) => {
  const { signinRedirect } = useAuth();
  const oidcStore = useOidcStore();
  const userManager = oidcStore.state.value.userManager;

  let user = oidcStore.state.value.user || (await userManager?.getUser());
  if (user) {
    oidcStore.actions.value.setUser(user);
    return next();
  }

  if (to.name === "oidcCallback") {
    return next();
  }

  if (!to.meta.isPublic) {
    signinRedirect({
      state: { redirectPath: to.fullPath },
    });
    return next(false);
  }
  next();
});
export default router;
